// extracted by mini-css-extract-plugin
export var dateLabel = "_2i-0";
export var dateLabelError = "_2i-1";
export var fullWidth = "_2i-2";
export var smaller = "_2i-3";